// Constants
// Errors
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
// Telemetry
import { resetLogHandler } from "../local/utilities/LogUtilities";
import { TraceLevel } from "./events/Trace.event";
import { EngagementLogger } from "./loggers/EngagementLogger";
import { PerformanceLogger } from "./loggers/PerformanceLogger";
import { TraceEventLogger } from "./loggers/TraceEventLogger";
import { UnhandledErrorHandler } from "./UnhandledErrorHandler";
import { UTelLogHandler } from "./UTelLogHandler";
import { scrubUrls } from "./utilities/UrlScrubber";
/** Logger manager to manage log handler for the app */ export class LoggerManager {
    /**
     * Get log handler to send events
     */ getLoggers() {
        return {
            logHandler: this.logHandler,
            traceLogger: this.traceEventLogger,
            engagementLogger: this.engagementLogger,
            performanceLogger: this.performanceLogger
        };
    }
    constructor(telemetryContext, privacyGuardContext, configProvider, appName){
        this.logHandler = new UTelLogHandler();
        this.configProvider = configProvider;
        resetLogHandler(telemetryContext, privacyGuardContext, this.logHandler, this.configProvider, appName);
        const { traceLogThreshold, blockedTraceTags } = this.configProvider().settings;
        const tracelevel = traceLogThreshold || TraceLevel.Info;
        const blockedTags = blockedTraceTags || [];
        this.traceEventLogger = new TraceEventLogger(tracelevel, this.logHandler, blockedTags);
        this.engagementLogger = new EngagementLogger(this.logHandler, this.traceEventLogger);
        this.performanceLogger = new PerformanceLogger(this.logHandler);
        UnhandledErrorHandler.registerUnhandledErrorHandler(this.traceEventLogger, configProvider().changeGates.DisableCallStackInUnhandledErrorLog, configProvider().changeGates.DisableMessageInUnhandledErrorLog);
        // Wire up EUII scrubbing for error messages flowing through ErrorUtilities
        ErrorUtilities.setRedactionFunction(scrubUrls);
    }
}
